import { TestCaseTemplate } from "../../../../types/testCaseTemplateTypes";
import { MainHeaderItem } from "../../mainHeaderItem/mainHeaderItem";
import {
  memo,
  useEffect,
  useState
} from "react";
import { ScenarioTestCase } from "../../../../types/scenarioTypes";
import { findScenarioExecuteResponse } from "../../../../store/selectors";
import {
  useDispatch,
  useSelector
} from "react-redux";
import {
  AppDispatch,
  RootState
} from "../../../../store";
import { setSelectedTestCase } from "../../../../store/slices/testCaseTemplateSlice";

type ScenarioMainHeaderItemProps = {
  testCase: ScenarioTestCase;
  onClickRerun: () => void;
  testCaseTemplates: Array<TestCaseTemplate>;
}

export const ScenarioMainHeaderItem = memo(({ testCaseTemplates, testCase, onClickRerun }: ScenarioMainHeaderItemProps) => {
  const dispatch = useDispatch<AppDispatch>()

  const selectedTestCase = useSelector((state: RootState) => state.testCaseTemplateSlice.selectedTestCase);

  const executeResponse = useSelector((state: RootState) => findScenarioExecuteResponse(state, testCase.internalId || ""));

  const [template, setTemplate] = useState<TestCaseTemplate>({
    name: "",
    responseParameters: [],
    priorityId: 0,
    requestHeaders: [],
    methodId: 0,
    environmentServers: [],
    childTestCases: [],
    statusCodeId: 0,
    isPositive: false,
    testCaseTemplateFolderId: 0,
    requestParameters: [],
    maximumExecutionTimeout: 0,
    isJsonSchemaValidation: false,
  });

  useEffect(() => {
      const findTemplate = testCaseTemplates?.find(item => item.id === testCase.testCaseTemplateId);
      if (!!findTemplate) {
        setTemplate(findTemplate);
      }
  }, [testCaseTemplates, testCase, setTemplate]);

  const onClickItem = (): void => {
    if (!!template.id) {
      dispatch(setSelectedTestCase({ testCase, template }));
    }
  }

  return (
    <MainHeaderItem testCaseTemplate={template}
                    testCase={testCase}
                    onClickRerun={onClickRerun}
                    executeResponse={executeResponse}
                    showEdit
                    needSelect
                    onClick={onClickItem}
                    selected={testCase.internalId === selectedTestCase.internalId}/>
  );
});
